import { memo } from 'react';

const LocationText = memo(({ location_address, ...locationGeo }) => {
  let locationGeoText = [...new Set(Object.values(locationGeo).map(item => item.label))];
  return <div>{locationGeoText.join('') + location_address}</div>;
});

export default LocationText;
